(() => {
  'use strict';

  if (window.__oneLuxuryOrderFormatInitialized) return;
  window.__oneLuxuryOrderFormatInitialized = true;

  const ROOT_SELECTOR = '#MainContent .m-product-info--wrapper';
  const STATE_SELECTOR = '.one-luxury-availability--product[data-one-luxury-availability]';
  const INJECTED_SELECTOR = '[data-one-luxury-order-format]';
  const LEGACY_SELECTOR = [
    '.one-luxury-pdp-trust',
    '.one-luxury-secure-shipping',
    '.one-luxury-pdp-system__trust',
    '.one-luxury-pdp-system__shipping'
  ].join(',');

  let scheduled = false;

  function availabilityState(root) {
    return root.querySelector(STATE_SELECTOR);
  }

  function compactText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function removeUnverifiedPickup(root) {
    root.querySelectorAll([
      '.one-luxury-pickup-note',
      '[id^="OneLuxuryPickup-"]',
      '.one-luxury-secure-shipping__pickup',
      '.one-luxury-pdp-system__pickup',
      '[data-one-luxury-pickup]',
      'a[href*="product_private_pickup"]'
    ].join(',')).forEach((node) => node.remove());

    root.querySelectorAll('p, li, small, span, h2, h3, h4, summary, a').forEach((node) => {
      const text = compactText(node.textContent);
      if (!text || text.length > 320) return;
      if (
        !text.includes('miami private pickup') &&
        !text.includes('miami pickup') &&
        !text.includes('private pickup is available')
      ) return;

      const removable = node.closest(
        '.main-product__block-custom_liquid, aside, section, details, p, li'
      ) || node;
      removable.remove();
    });
  }

  function isCheckoutEligible(state) {
    if (!state) return false;

    const price = Number(state.dataset.availabilityVariantPrice || 0);
    const mode = state.dataset.availabilityMode || '';
    const ctaType = state.dataset.availabilityCtaType || '';

    return state.dataset.availabilityPurchasable === 'true' &&
      ctaType === 'cart' &&
      (mode === 'ready_to_ship' || mode === 'made_to_order') &&
      price >= 500 &&
      price <= 990000;
  }

  function setLegacyVisibility(root, hidden) {
    root.querySelectorAll(LEGACY_SELECTOR).forEach((node) => {
      const host = node.closest('.main-product__block-custom_liquid, .main-product__block') || node;
      if (hidden) {
        if (!host.hasAttribute('data-one-luxury-original-hidden')) {
          host.setAttribute('data-one-luxury-original-hidden', host.hidden ? 'true' : 'false');
        }
        host.hidden = true;
        host.setAttribute('aria-hidden', 'true');
      } else if (host.hasAttribute('data-one-luxury-original-hidden')) {
        host.hidden = host.getAttribute('data-one-luxury-original-hidden') === 'true';
        if (!host.hidden) host.removeAttribute('aria-hidden');
        host.removeAttribute('data-one-luxury-original-hidden');
      }
    });
  }

  function buildTrustPanel(statusText) {
    const panel = document.createElement('section');
    panel.className = 'one-luxury-order-panel';
    panel.dataset.oneLuxuryOrderFormat = 'trust';
    panel.setAttribute('aria-label', 'Ordering highlights');

    const items = [
      statusText || 'Availability shown for the selected configuration',
      'Secure checkout with order review',
      'Delivery terms confirmed before fulfillment'
    ];

    const list = document.createElement('ul');
    list.className = 'one-luxury-order-panel__list';
    list.setAttribute('role', 'list');

    items.forEach((text) => {
      const item = document.createElement('li');
      const marker = document.createElement('span');
      const copy = document.createElement('span');
      marker.className = 'one-luxury-order-panel__diamond';
      marker.setAttribute('aria-hidden', 'true');
      copy.textContent = text;
      item.append(marker, copy);
      list.append(item);
    });

    panel.append(list);
    return panel;
  }

  function buildDeliveryDetails() {
    const details = document.createElement('details');
    details.className = 'one-luxury-order-shipping';
    details.dataset.oneLuxuryOrderFormat = 'delivery';

    const summary = document.createElement('summary');
    const title = document.createElement('span');
    const indicator = document.createElement('span');
    title.textContent = 'Delivery and fulfillment';
    indicator.className = 'one-luxury-order-shipping__indicator';
    indicator.setAttribute('aria-hidden', 'true');
    summary.append(title, indicator);

    const body = document.createElement('div');
    const copy = document.createElement('p');
    body.className = 'one-luxury-order-shipping__body';
    copy.textContent = 'Delivery timing, tracking, signature requirements, and any applicable insurance are confirmed in written order documentation before fulfillment.';
    body.append(copy);
    details.append(summary, body);
    return details;
  }

  function apply(root) {
    removeUnverifiedPickup(root);
    const state = availabilityState(root);
    const eligible = isCheckoutEligible(state);
    root.classList.toggle('one-luxury-order-format-active', eligible);

    if (!eligible) {
      root.querySelectorAll(INJECTED_SELECTOR).forEach((node) => node.remove());
      setLegacyVisibility(root, false);
      return false;
    }

    setLegacyVisibility(root, true);
    const buyBlock = root.querySelector('.main-product__block-buy_buttons');
    if (!buyBlock) return true;

    const label = state.querySelector('[data-availability-label]')?.textContent?.trim();
    if (!root.querySelector('[data-one-luxury-order-format="trust"]')) {
      buyBlock.before(buildTrustPanel(label));
    }
    if (!root.querySelector('[data-one-luxury-order-format="delivery"]')) {
      buyBlock.after(buildDeliveryDetails());
    }

    return true;
  }

  function run() {
    scheduled = false;
    let anyEligible = false;
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      anyEligible = apply(root) || anyEligible;
    });
    document.body?.classList.toggle('one-luxury-order-format-active', anyEligible);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('variant:changed', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  window.setTimeout(schedule, 400);
})();
